import { useViewSuperblocksV2Context } from "contexts/ViewSuperblocksV2Context";
import { useMemo } from "react";

import { OrgFeature, orgHasFeature } from "@superblocksteam/shared";

/**
 * Hook to check if the current organization has access to a specific feature.
 *
 * Uses the effective org version from ViewSuperblocksV2Context, which accounts
 * for V1 orgs previewing the V2 experience via the toggle.
 *
 * @param feature - The feature to check access for
 * @returns true if the organization has access to the feature
 */
export function useOrgFeature(feature: OrgFeature): boolean {
  const { effectiveOrgVersion } = useViewSuperblocksV2Context();

  return useMemo(
    () => orgHasFeature(effectiveOrgVersion, feature),
    [effectiveOrgVersion, feature],
  );
}
